'use client';

import Link from 'next/link';
import { SmartFormattedMessage } from '@/components/smart-formatted-message';
import { useRouteErrorCapture } from '@/hooks/use-route-error-capture';
import { ErrorLanguageProvider } from './error-language-provider';

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  const { deploymentSkew } = useRouteErrorCapture(error, 'global');

  return (
    <html>
      <body>
        <ErrorLanguageProvider>
          <div className="flex h-screen w-screen items-center justify-center">
            <div className="space-y-4 text-center">
              <h1 className="text-xl font-semibold">Something went wrong!</h1>
              {deploymentSkew && (
                <p>
                  <SmartFormattedMessage
                    defaultMessage="This page needs an update. Reload it, then try your action again."
                    description="Instruction after an open tab calls an action from an older release"
                  />
                </p>
              )}
              {error.digest && (
                <p className="font-mono text-xs text-gray-400">
                  Error ID: {error.digest}
                </p>
              )}
              <div className="flex flex-wrap justify-center gap-3">
                {deploymentSkew ? (
                  <button
                    onClick={() => window.location.reload()}
                    className="text-primary"
                  >
                    <SmartFormattedMessage
                      defaultMessage="Reload page"
                      description="Button to load the current release after a stale Server Action"
                    />
                  </button>
                ) : (
                  <Link href="/" className="text-primary">
                    Return Home
                  </Link>
                )}
              </div>
            </div>
          </div>
        </ErrorLanguageProvider>
      </body>
    </html>
  );
}
